import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import useUserData from '../../../hooks/DataProvider/useUserData'
import useRoleData from '../../../hooks/DataProvider/useRoleData'
import MaterialTable from 'material-table'
import EditUserModal from '../../Modals/Users/EditUserModal'

import GenericModal from '../../Modals/GenericModal'

import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';

import moment from 'moment';

import axios from 'axios';
import {DELETE_USER} from '../../../api/Api';


const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
}));

function entierAleatoire(min, max)
{
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default function UserList(props) {
    const classes = useStyles();

    const [reloadListKey,setReloadListKey] = React.useState(34);

    const [isLoadingUsers,loadingErrors,users] = useUserData(undefined,undefined,reloadListKey);

    const [usersToDelete,setUsersToDelete] = React.useState([]);
    const [isDeletingUser,setIsDeletingUser] = React.useState(false);

    const [userToEdit,setUserToEdit] = React.useState(undefined);
    const [isEditingUser,setIsEditingUser] = React.useState(false)

    const hydratedUsers = React.useMemo(
        () => {

            const hydrateds = users.map(
                user => {
                    return {
                        ...user
                    }
                }
            );

            return hydrateds;
        }, [users]
    )

    React.useEffect(
        () => {
            setReloadListKey(entierAleatoire(1,99999));
        },[props.reloadKey]
    )

    console.log(hydratedUsers)

    function reloadUserList(){
        setReloadListKey(entierAleatoire(1,999))
    }

    async function deleteUsers(user){

        setIsDeletingUser(true)

        try{

            const response = (await axios.delete(
                `${DELETE_USER}/${user.id}`
            ));

            if(response.status === 204){

                //reload users
                setUsersToDelete([]);
                reloadUserList();

            } else {
                console.log('Some error happen');
            }

        } catch (e) {

        } finally {
            setIsDeletingUser(false)
        }

    }

    return (
            <div>
                               
                    {/*<Table className={classes.table}>*/}
                    {/*    <TableHead>*/}
                    {/*        <TableRow>*/}
                    {/*            <StyledTableCell>id</StyledTableCell>*/}
                    {/*            <StyledTableCell>Nom</StyledTableCell>*/}
                    {/*            <StyledTableCell align="right">Prenoms</StyledTableCell>*/}
                    {/*            <StyledTableCell align="right">Téléphone</StyledTableCell>*/}
                    {/*            <StyledTableCell align="right">Email</StyledTableCell>*/}
                    {/*            <StyledTableCell align="right">Exploitation</StyledTableCell>*/}
                    {/*            <StyledTableCell align="right">role</StyledTableCell>*/}
                    {/*        </TableRow>*/}
                    {/*    </TableHead>*/}
                    {/*    <TableBody>*/}
                    {/*        {users.map(user => (*/}
                    {/*            <StyledTableRow key={user.id}>*/}
                    {/*                <StyledTableCell component="th" scope="row">*/}
                    {/*                    {user.id}*/}
                    {/*                </StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.nom}</StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.prenoms}</StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.phone}</StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.email}</StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.exploitation}</StyledTableCell>*/}
                    {/*                <StyledTableCell align="right">{user.role}</StyledTableCell>*/}
                    {/*            </StyledTableRow>*/}
                    {/*        ))}*/}
                    {/*    </TableBody>*/}
                    {/*</Table>*/}

                Type de compte ,
                Nom, Prénom(s),
                Numéro de Téléphone,
                Société (Liste Déroulante: CIE ou SODECI),
                N° Matricule,
                adresse email,
                Date de dernière connexion
                <MaterialTable
                    columns={[
                        { title: 'Type de compte', field: 'roles.0.name' },
                        { title: 'nom', field: 'nom' },
                        { title: 'prenoms', field: 'prenoms' },
                        { title: 'Téléphone', field: 'phone', },
                        { title: 'Matricule', field: 'matricule', },
                        { title: 'email', field: 'email', },
                        { title: 'Societe', field: 'societe', },
                        { title: 'Dernière connexion',  render: (data)=>{
                                return (
                                    <div>
                                        {
                                            moment(data.last_activity_time).format('DD/MM/YYYY hh:mm')
                                        }
                                    </div>
                                )
                            } },
                        { title: 'Action', render: (data)=>{
                            return (
                                <div>
                                    <IconButton
                                        onClick={()=>{
                                            setUsersToDelete([data])
                                        }}
                                        aria-label="Upload picture"
                                        component="span"
                                    >
                                        <DeleteIcon />
                                    </IconButton>

                                    <IconButton
                                        onClick={()=>{
                                            setUserToEdit(data)
                                        }}
                                        aria-label="Upload picture"
                                        component="span"
                                    >
                                        <Edit />
                                    </IconButton>

                                </div>
                        )
                    } },
                    ]}
                    title={''}
                    isLoading={isLoadingUsers}
                        data={hydratedUsers}
                />


                {
                    usersToDelete.length > 0 && (
                        <GenericModal
                            title={'Supprimer l\'utilisateur'}
                            isOpen={true}
                            positiveText={'Oui'}
                            negativeText={'Non'}
                            onNegative={() => {
                                setUsersToDelete([])
                            }}
                            onPositive={
                                () => {
                                    deleteUsers(usersToDelete[0])
                                }
                            }
                        >

                            {
                                usersToDelete.length === 1 && (
                                    <div>
                                        Êtes vous sur de vouloir suprimmer l'utilisateur sélectionnée ?
                                    </div>
                                )
                            }

                            {
                                usersToDelete.length > 1 && (
                                    <div>
                                        Êtes vous sur de vouloir suprimmer les {usersToDelete.length} utilisateurs sélectionnées ?
                                    </div>
                                )
                            }

                        </GenericModal>
                    )
                }

                {
                    userToEdit && (
                        <EditUserModal
                            user={userToEdit}
                            isOpen={true}
                            onCancel={()=>{
                                setUserToEdit()
                            }}
                            onUserUpdated={
                                ()=>{
                                    reloadUserList();
                                    setUserToEdit(undefined);
                                }
                            }
                        />
                    )
                }

            </div>
        );
}
